/**
 * Where a Google consent popup lands: a tenant-less page (a reserved slug, so
 * no tenant can own it) that tells the tab which opened the popup how the
 * consent ended, then closes itself. It needs no session, which is why it is
 * not under `/<tenant>/` — there the popup would meet the login gate.
 */
export const GOOGLE_ACCESS_PATH = '/google-access';

/** True for `/google-access` (a trailing slash is the same page). */
export function isGoogleAccessPath(pathname: string): boolean {
  return pathname.replace(/\/+$/, '') === GOOGLE_ACCESS_PATH;
}
